
import SearchForm from './SearchForm.vue'
import NoFound from '../Shared/NoFound/index.vue'
export default { components: { SearchForm, NoFound } }
